import { Controller } from "@hotwired/stimulus"

// Fills stars 1..N when the Nth radio is selected (classic 1–5 rating UX).
export default class extends Controller {
  static targets = ["face"]

  connect() {
    this._apply()
  }

  update() {
    this._apply()
  }

  _apply() {
    const input = this.element.querySelector("input[type=radio]:checked")
    const n = input ? parseInt(input.value, 10) : 0

    this.faceTargets.forEach((el, i) => {
      if (i < n) {
        el.classList.add("bg-yellow-400", "text-white")
        el.classList.remove("bg-gray-100", "text-gray-400")
      } else {
        el.classList.remove("bg-yellow-400", "text-white")
        el.classList.add("bg-gray-100", "text-gray-400")
      }
    })
  }
}
